import { render, staticRenderFns } from "./TemporadasCRUD.vue?vue&type=template&id=17772dba"
import script from "./TemporadasCRUD.vue?vue&type=script&lang=js"
export * from "./TemporadasCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports